import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Base from './input-base';
import { getMouseCoordinate } from '../../../fc-core/src/lib';

var correctZoomRatio = function correctZoomRatio(a) {
  return 0 > a ? -a : a;
},
    max = Math.max,
    min = Math.min,
    getZoomRange = function getZoomRange(a, b, c, d, e) {
  var f = Math.round,
      g = a.getVisibleConfig(),
      h = a.getValue(b[d ? 'y' : 'x'] + a.getTranslation()),
      i = h - g.minValue,
      j = g.maxValue - h,
      k = a.config.axisRange;
  return {
    min: f(max(k.min, h - i / c) * e) / e,
    max: f(min(k.max, h + j / c) * e) / e
  };
};

var InputPinchZoom =
/*#__PURE__*/
function (_Base) {
  _inherits(InputPinchZoom, _Base);

  function InputPinchZoom() {
    var _this;

    _classCallCheck(this, InputPinchZoom);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputPinchZoom).call(this));

    var a = _assertThisInitialized(_assertThisInitialized(_this));

    a.controlArr = [{
      nativeInteraction: ['fc-pinchstart'],
      callback: a.pinchstart.bind(a),
      component: a
    }, {
      nativeInteraction: ['fc-pinchmove'],
      callback: a.pinchmove.bind(a),
      component: a
    }];
    return _this;
  }

  _createClass(InputPinchZoom, [{
    key: "getName",
    value: function getName() {
      return 'pinchZoom';
    }
  }, {
    key: "configure",
    value: function configure() {
      _get(_getPrototypeOf(InputPinchZoom.prototype), "configure", this).call(this), this.enable();
    }
  }, {
    key: "getCenter",
    value: function getCenter(a, b) {
      var c = this.getFromEnv('chart'),
          d = getMouseCoordinate(c.getLinkedItem('container'), {
        pageX: (a.pageX + b.pageX) / 2,
        pageY: (a.pageY + b.pageY) / 2
      }, c);
      return {
        x: d.chartX,
        y: d.chartY
      };
    }
  }, {
    key: "pinchmove",
    value: function pinchmove(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          i,
          j = this,
          k = a.originalEvent.data,
          l = k.distanceX,
          m = k.distanceY,
          n = j.config,
          o = n.touchConfig,
          p = {},
          q = !1,
          r = {},
          s = j.getFromEnv('chart'),
          t = j.getFromEnv('axesObArr'),
          u = Math.pow(10, n.zoomDecimalLimit) || 1,
          v = s.getChildContainer().plotGroup;
      b = correctZoomRatio(l / o.distanceX), c = correctZoomRatio(m / o.distanceY), t.forEach(function () {
        v.transform(''), v.scale(b, c, o.center.x, o.center.y);
      }), clearTimeout(n.chartDraw), n.chartDraw = setTimeout(function () {
        v.transform(''), t.forEach(function (a) {
          var k = a.axis,
              l = getZoomRange(k, o.center, a.isY ? c : b, a.isY, u),
              m = l.min,
              n = l.max,
              s = a.stack,
              t = k.getVisibleConfig(),
              v = k.getLimit(),
              w = s.length - 1,
              x = s[w],
              y = Math.floor(m) === v.min && Math.ceil(n) === v.max,
              z = k.getZoom() >= u;
          if (!x) y || z || (s.push(t), p.zoomin = !0);else if (y) a.stack = [], p.zoomout = !0;else if (x.minValue > m && x.maxValue < n) {
            for (; x && x.minValue > m && x.maxValue < n;) {
              s.pop(), x = s[--w];
            }

            p.zoomout = !0;
          } else z || (s.push(t), p.zoomin = !0);
          a.isY ? (g = m, h = n) : (e = m, f = n, r = j.constructor._getZoomInfo(e, f, k)), i = a.stack.length + 1, d = k.setVisibleConfig(m, n), q = q || d;
        }), q && (p.zoomout && j._raiseZoomEvents('zoomout', 'zoomedout', Object.assign(r, {
          level: i,
          startX: e,
          endX: f,
          startY: g,
          endY: h
        })), p.zoomin && j._raiseZoomEvents('zoomin', 'zoomedin', Object.assign(r, {
          level: i,
          startX: e,
          endX: f,
          startY: g,
          endY: h
        }))), n.chartDraw = null;
      }, 250);
    }
  }, {
    key: "pinchstart",
    value: function pinchstart(a) {
      var b,
          c = this,
          d = c.getFromEnv('axesObArr'),
          e = a.originalEvent.data,
          f = e;
      this.getFromEnv('animationManager').setAnimationState('touch'), f.center = c.getCenter(e.finger0, e.finger1), c.config.touchConfig = e, d.forEach(function (a) {
        b = a.axis, a.visibleConfig = b.getVisibleConfig(), a.centerVal = b.getValue(a.isY ? f.center.y : f.center.x);
      });
    }
  }, {
    key: "setControl",
    value: function setControl() {
      var a = this,
          b = a.getLinkedParent(),
          c = a.controlArr;
      b.releaseControl(c), a.isEnabled() && b.getControl(c);
    }
  }]);

  return InputPinchZoom;
}(Base);

export default InputPinchZoom;